<template>
    <div @click="closeModal" class="addon-modal-page">
        <div  id="addonModal" ref="addonModal" v-on:click.stop class="addon-modal-container">
            <img @click="closeModal()" class="x" src="https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652" alt="x"/>
            <div class="addon-container">
                <div class="images-container">
                    <span v-if="mainBadge != null" class="main-badge">{{mainBadge}}</span>
                    <img :src="currentMainImage" class="main-image">
                    <div class="extra-images-container">
                        <Flicking ref="flicking" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true,renderOnlyVisible: true,horizontal: false }">
                            <img 
                                v-for="image in selectedAddon.images" 
                                :key="image.id"
                                class="extra-image lazyload"
                                :class="image.src == currentMainImage ? 'selected' : ''"
                                :src="image.src"
                                @click="selectImage(image.src)"
                            >
                        </Flicking>
                    </div>
                </div>
                <div class="data-container">
                    <p class="title">{{selectedAddon.title}}</p>
                    <div v-if="hasVariants" class="variant-container">
                        <p class="variant-title">Choose one:</p>
                        <div class="variants-button-container">
                            <button :class="selectedVariant == i ? 'selected' : ''" @click="selectVariant(i)" v-for="(variant,i) in this.selectedAddon.variants" :key="variant.id">
                                {{variant.title.replaceAll("Price /","").replaceAll("Happy Choice /","")}}
                            </button>
                        </div>
                    </div>
                    <div v-if="ethosTags.length > 0 || showOnDemand" class="ethos-container">
                        <span :class="badgeExtraClass(etho)" v-for="etho in ethosTags" :key="etho">{{etho}}</span>
                        <span class="purple-ethos" v-if="showOnDemand">Ships in 1-2 weeks</span>
                    </div>
                    <p class="desc-label">Description</p>
                    <p class="desc" v-html="productDesc"></p>
                    <div class="alergen-container">
                        <span v-for="dietary in dietaryTags" :key="dietary">{{dietary}}</span>
                    </div>
                    <div v-if="allergens" class="ingredient-container">
                        <p><strong>ALLERGENS:</strong> {{allergens}}</p>
                    </div>
                    <p @click="changeMinBoxQty" v-if="customAlert != ''" v-html="customAlert" class="red-alert"></p>
                    <button @click="updateMainAddonProductQuantity(1)" v-if="currentQty == 0" class="happybox-button green border"> {{addCopy}} - {{productPrice | moneySaleFormat}} </button>
                    <div class="selector-container" v-else-if="currentQty > 0 && manualInput == false">
                        <div class="selector-shown">
                            <div class="quantity-show" @click="openSelector"><i class="arrow down"></i><span>QTY / BOX <br> {{currentQty}}</span></div>
                            <div class="separator"></div>
                            <div class="box-show"> IN BOX</div>
                        </div>
                        <div class="selector-options" v-if="isSelectorOpen == true">
                            <button v-for="qty in addonMaxSelectors" :key="qty" @click="onSelectorValueChange(qty)">{{qty}} in a box</button>
                            <button class="custom" @click="onSelectorValueChange('custom')">Custom Amount</button>
                            <button class="remove" @click="onSelectorValueChange('remove')">Remove from box</button>
                        </div>
                    </div>
                    <div class="input-container" v-else>
                        <input v-model="manualInputQty" :min="1" :max="productMaxQty" type="number">
                        <button @click="updateMainAddonProductQuantity(manualInputQty)" class="happybox-button green border"> UPDATE BOX</button>
                    </div>
              </div>
          </div>
          <div v-if="recommendedAddons.length > 0" class="recommendation-container">
                <div @click="scroll(true)" class="arrow left"></div>
                <p class="title">Add more gifts:</p>
                <div class="side-scroller" id="sideScroller">
                        <div class="recommended-addon" v-for="addon in recommendedAddons" :key="addon.id">
                            <img @click="changeAddon(addon)" :src="addon | getProductImage" class="main-image">
                            <button @click="updateReccomendedAddonProductQuantity(addon)" class="happybox-button white border">{{ addCopy }}</button>
                            <p class="addon-title">{{addon.title}}</p>
                            <p class="price">{{addon.variants[0].price | moneySaleFormat}}</p>
                        </div>
                </div>
                <div class="arrow right" @click="scroll(false)"></div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel'
import Swal from 'sweetalert2/dist/sweetalert2.js'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
    components: {
        VueSlickCarousel,
    },
    props: {
        selectedAddon: Object,
        addonProducts: Array,
        cartProducts: Array,
        recommendedProducts: Array,
    },
    data() {
      return {
          selectedImage: null,
          manualInput: false,
          manualInputQty: 0,
          selectorValue: "1",
          isSelectorOpen: false,
          selectedVariant: 0,
          customAlert: '',
          oosProducts: [],
          oldBoxQty: 0,
      }
    },
    computed:{
        ...mapGetters([
          'maxCapacity',
          'currentCapacity',
          'productLimit',
          'addCopy'
        ]),
        boxQty: {
            get(){ return this.$store.state.boxQty},
            set(value){this.$store.commit('setBoxQty', value )}
        },
        productPrice(){
            return this.selectedAddon.variants.find(x => x.price != "").price
        },
        currentMainImage(){
            if(this.selectedImage){
                return this.selectedImage;
            }
            else {
               return this.selectedAddon.images[0].src
            }
        },
        currentMainImageIndex(){
            if(this.selectedImage){
                let index = this.selectedAddon.images.findIndex(x => x.src == this.selectedImage)
                if(index > -1)
                    return index
            }

            return 0
        },
        recommendedAddons(){
            return this.recommendedProducts.filter(x => x.id != this.selectedAddon.id);
        },
        mainBadge(){
            //Check badges in the following order. 
            //Almost gone: Invetory < 20
            //Best seller: has "Filter_Badges_Best Seller" tag
            // New: has been published for less that 60 days
            var inventory =  this.currentVariantInventory;
            if(inventory < 20)
                return "Less than 20";

            var badge = this.selectedAddon.tags.find(y => y.includes("Filter_Badges"));
            if(badge){
                badge = badge.replace("Filter_","").split("_")
                return badge[1];
            }

            return null
        },
        currentQty(){
            var product = {};
            if(this.isOnDemand)
                product = this.cartProducts.find(x => x.id == this.currentVariantProduct.id);
            else
                product = this.cartProducts.find(x => x.variants[0].id == this.currentVariantProduct.variants[0].id);
            if(product)
                return product.quantity
            return 0
        },
        productMaxQty(){
            //Get max value posible in products, no more than the product limit per box
            var maxValues = [this.productLimit]
            //Get limit based on inventory * total boxes
            maxValues.push(Math.floor(this.currentVariantInventory / this.boxQty));
            //Get limit based on currentCapacity
            maxValues.push(Math.floor(((this.maxCapacity - this.currentCapacity) / this.selectedAddon.capacity) + this.currentQty));

            return Math.min(...maxValues)
        },
        addonMaxSelectors(){
            const min = 1,
            max = Math.min(5,this.productMaxQty),
            interval = 1;
            const length = (max - min) / interval + 1;
            var arr = Array.from({ length }, (_, i) => min + i * interval);

            if(this.demandQtyMin > 0){
                arr = this.checkOnDemandArray(arr);
            }

            return arr;
        },
        currentAddonIndex(){
            if(this.selectedAddon){
                let index = this.addonProducts.findIndex(x => x.id == this.selectedAddon.id)
                if(index > -1)
                    return index
            }

            return 0
        },
        ethosTags(){
            if(this.selectedAddon){
                var ethos = this.selectedAddon.tags.filter(y => y.includes("Filter_Ethos"));
                ethos = ethos.map((x) => {
                    var currentEthos = x.replace("Filter_","").split("_")
                    return currentEthos[1]
                })
                return ethos;
            }

            return []
        },
        dietaryTags(){
            if(this.selectedAddon){
                var dietary = this.selectedAddon.tags.filter(y => y.includes("Filter_Allergen"));
                dietary = dietary.map((x) => {
                    var currentDietary = x.replace("Filter_","").split("_")
                    return currentDietary[1]
                })
                return dietary.sort();
            }

            return []
        },
        hasVariants(){
            return this.selectedAddon.variants.length > 1 && this.selectedAddon.variants.every(x => !x.sku.toLowerCase().includes("ondemand"));
        },
        currentVariantProduct(){
            if(this.isOnDemand){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                let currentQty = this.cartProducts.find(x => x.id == variantProduct.id);
                currentQty = currentQty ? currentQty.quantity : 0;
                if(notDemand.inventory_quantity >= currentQty * this.boxQty  || this.demandQtyMin > this.boxQty * currentQty){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                return variantProduct;
            }
            else if(this.hasVariants){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                variantProduct.variants = [variantProduct.variants[this.selectedVariant]]

                return variantProduct;
            }
            return this.selectedAddon;
        },
        currentVariantInventory(){
            //if(this.isOnDemand && this.demandQtyMin <= this.boxQty)
            if(this.isOnDemand)
                return 9999;
            return this.currentVariantProduct.variants[0].inventory_quantity;
        },
        productDesc(){
            var desc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;")[0];
            return desc;
        },
        allergens(){
            var splitDesc = this.selectedAddon.body_html.split("&lt;---ingredients---&gt;");
            if(splitDesc.length > 1){
                return splitDesc[1].replace( /(<([^>]+)>)/ig, '').replaceAll('&amp;','&').replaceAll('&nbsp;',' ');
            }

            return null
        },
        hasQtyMin(){
            return this.selectedAddon.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
        },
        hasDemandQtyMin(){
            return this.selectedAddon.tags.find(x => x.includes("DEMAND_QTYMIN"));
        },
        isOnDemand(){
            return this.selectedAddon.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        showOnDemand(){
            if(this.isOnDemand){
                if(this.currentVariantProduct)
                    return this.currentVariantProduct.variants[0].sku.toLowerCase().includes("ondemand");
            }

            return false;
        },
        customQtyMin(){
            if(this.hasQtyMin){
                let minTag = this.selectedAddon.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
        demandQtyMin(){
            if(this.hasDemandQtyMin){
                let minTag = this.selectedAddon.tags.find(x => x.includes("DEMAND_QTYMIN"));
                if(minTag){
                    minTag = minTag.split("_");
                    minTag = minTag[minTag.length - 1];

                    return  parseInt(minTag);
                }
            }

            return 0;
        },
    },
    methods:{
        closeModal(){
            if(this.oosProducts.length > 0){
                this.openBoxConfirmation();
                return;
            }
            this.$emit("closemodal");
        },
        selectImage(src){
            this.selectedImage = src;
        },
        getProductCurrentQty(currentProduct){
          var product = this.cartProducts.find(x => x.id == currentProduct.id);
          if(product)
            return product.quantity
          return 0
        },
        updateMainAddonProductQuantity(quantity){
            this.customAlert = '';
            if(this.hasQtyMin){
                if(this.customQtyMin > this.boxQty){
                    this.customAlert = `This product requires a minimum order of ${this.customQtyMin}. <strong style='font-weight: 400; text-decoration: underline;'>Click here to update your box quantity.</strong>`;
                    return;
                }
            }
            let maxQty = 0;
            if(this.demandQtyMin > 0){
                if((this.boxQty * quantity) >= this.demandQtyMin)
                    maxQty = 9999;
                else{
                    let notDemand = this.selectedAddon.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                    var maxValues = [this.productLimit]
                    //Get limit based on inventory * total boxes
                    maxValues.push(Math.floor(notDemand.inventory_quantity / this.boxQty));
                    //Get limit based on currentCapacity
                    maxValues.push(Math.floor(((this.maxCapacity - this.currentCapacity) / this.selectedAddon.capacity) + this.currentQty));

                    maxQty = Math.min(...maxValues)
                }
            }
            else
                maxQty = this.productMaxQty;
            var maxPosible = Math.min(quantity,maxQty);
            this.updateAddonProduct(this.currentVariantProduct,maxPosible)
            this.manualInput = false;
            this.selectorValue = maxPosible;
        },
        updateReccomendedAddonProductQuantity(product){
            var isBrandable = product.tags.filter(y => y.includes("Brandable Swag"));
            if(isBrandable && isBrandable.length > 0){
                this.changeAddon(product);
                return;
            }
            var productQty = this.getProductCurrentQty(product) + 1;
            this.updateAddonProduct(product,productQty)
            this.closeModal();
        },
        onSelectorValueChange(value){
            this.isSelectorOpen = false;
            switch (value) {
                case 'remove':
                    this.updateAddonProduct(this.currentVariantProduct,0)
                    break;
                case 'custom':
                    this.manualInput = true;
                    this.manualInputQty = this.currentQty;
                    break;
                default:
                    this.updateMainAddonProductQuantity(value);
                    break;
            }
        },
        updateAddonProduct(product,quantity){
            let isOnDemand = product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
            let currentQty = this.currentQty;
            if(isOnDemand){
                var variantProduct = JSON.parse(JSON.stringify(this.selectedAddon));
                let notDemand = variantProduct.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
                let onDemand = variantProduct.variants.find(x => x.sku.toLowerCase().includes("ondemand"));
                if(notDemand.inventory_quantity >= quantity * this.boxQty || this.demandQtyMin > this.boxQty * quantity){
                    variantProduct.variants = [notDemand];
                }
                else 
                    variantProduct.variants = [onDemand];

                this.$store.commit('updateSelectedAddonProductsNew',{product: this.currentVariantProduct, quantity: 0});
                this.$store.commit('updateSelectedAddonProductsNew',{product: variantProduct, quantity: quantity});
            }
            else {
                this.$store.commit('updateSelectedAddonProductsNew',{product: product, quantity: quantity});
                if(currentQty == 0){
                    this.closeModal();
                }
            }
                
        },
        openSelector(){
            this.isSelectorOpen = true;
        },
        dateDiffInDays(a, b) {
            const _MS_PER_DAY = 1000 * 60 * 60 * 24;
            // Discard the time and time-zone information.
            const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
            const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
            return Math.floor((utc2 - utc1) / _MS_PER_DAY);
        },
        nextAddon(next){
            if(this.oosProducts.length > 0){
                this.openBoxConfirmation();
                return
            }
            var maxIndex = this.addonProducts.length - 1
            var nextAddon = null;
            if(next){
                if(this.currentAddonIndex == maxIndex)
                    nextAddon = this.addonProducts[0]
                else
                    nextAddon = this.addonProducts[this.currentAddonIndex + 1]
                
            }
            else {
                if(this.currentAddonIndex == 0)
                    nextAddon = this.addonProducts[maxIndex]
                else
                    nextAddon = this.addonProducts[this.currentAddonIndex - 1]
            }
            this.selectedImage = null;
            this.$emit("changeselectedaddon", nextAddon);
        },
        changeAddon(addon){
            if(this.oosProducts.length > 0){
                this.openBoxConfirmation();
                return
            }
            this.selectedImage = null;
            this.$emit("changeselectedaddon", addon);
            this.$nextTick(() => {
                this.$refs.addonModal.scrollTop = 0;
            });
        },
        selectVariant(i){
            this.selectedVariant = i;
        },
        scroll(toLeft){
            const scrollWrapper = document.getElementById('sideScroller');
            var width = scrollWrapper.width();
            var totalWidth = scrollWrapper[0].scrollWidth
            var scrollPosition = scrollWrapper.scrollLeft();
            let scrollDistance = Math.round(scrollPosition / width);
            let totalDistance = Math.round(totalWidth / width);
            scrollDistance = toLeft ? Math.max(...[scrollDistance - 1,0]) : scrollDistance + 1;
            if(scrollPosition == 0 && toLeft)
                scrollWrapper.scrollLeft(totalWidth);
            else if(scrollDistance >= totalDistance && !toLeft)
                scrollWrapper.scrollLeft(0);
            else
                scrollWrapper.scrollLeft(scrollDistance * width);
        },
        //Change box qty
        changeMinBoxQty(){
            var canUpdate = this.cartProducts.filter((x) =>{
                if((this.customQtyMin * (x.quantity)) >= x.variants[0].inventory_quantity)
                    return true

                return false
            })

            if(canUpdate.length > 0){
                this.oosProducts = canUpdate;
                this.oldBoxQty = this.boxQty;
            }

            this.boxQty = this.customQtyMin;
            this.customAlert = '';
        },
        openBoxQtyConfirmation(productList){
            var productTitles = productList.map(x => x.title);
            const alertText = `<p class="title">Uh oh</p><p>The following product(s) don't have enough inventory to match the quantity of boxes you've requested: ${productTitles.join(", ")} . Here are your options:</p>`
            Swal.fire({
                iconHtml: `<img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>`,
                html: alertText,
                showCancelButton: true,
                confirmButtonText: "I'll remove them from all boxes (& maybe add something else!)",
                cancelButtonText: "I'll take what you have (& reduce my number of boxes)",
                customClass:{
                container:"swal-custom-container",
                popup: "swal-custom-popup-3",
                title:"swal-title",
                confirmButton: "happybox-button green border",
                cancelButton: "happybox-button white border",
                },
                buttonsStyling: false,
                }).then((result) => {
                if (result.isConfirmed) {
                    for(let addon of productList){
                        this.removeProduct(addon);
                    }
                    this.customAlert = '';
                    this.oosProducts = [];
                } else {
                    this.boxQty = this.oldBoxQty;
                    this.oosProducts = [];
                }
            })
        },
        openBoxConfirmation(){
            if(this.oosProducts.length > 0){
                this.openBoxQtyConfirmation(this.oosProducts);
            }
        },
        removeProduct(product){
            this.$store.commit('removeSelectedAddonProductNew', product);
        },
        checkOnDemandArray(arr){
            let demandMinQty = this.demandQtyMin;
            const notDemand = this.selectedAddon.variants.find(x => !x.sku.toLowerCase().includes("ondemand"));
            const notDemandInventory = notDemand.inventory_quantity;
            for(let int of arr){
                if((int * this.boxQty) < demandMinQty && (int * this.boxQty) > notDemandInventory)
                arr.splice(int-1,1);
            }

            return arr;
        },
        badgeExtraClass(badge){
          switch(badge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        }
    }
}
</script>

<style lang="scss" scoped>
.addon-modal-page{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 11;
}

.iframe-container{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.close-iframe{
    font-size: 2vw;
    cursor: pointer;
    position: absolute;
    top: 10%;
    right: 20%;
}

.addon-modal-container{
    width: 65%;
    background-color: white;
    max-height: 90%;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 4% 3% 3%;
    position: relative;
    box-shadow: 0 0 3px #00000050;
}

.slider-arrow{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #FFFFFF;
    border: 1px solid #F3EEFA;
    border-radius: 100px;
    position: absolute;
    top: 45%;
    height: 40px;
    width: 40px;
    font-size: 2vw;
    color: black;
    cursor: pointer;
}

.slider-arrow.left{
    left: 7%;
}

.slider-arrow.right{
    right: 7%;
}

.addon-modal-container::-webkit-scrollbar{
    width: 0;
}

.addon-container{
    width: 100%;
    display: flex;
}

.images-container{
    width: 50%;
    position: relative;
    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    gap: 2%;
    align-items: flex-start;
}

.main-badge{
    background-color: white;
    position: absolute;
    top: 2%;
    left: 20%;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1%;
    font-size: 1vw;
    font-weight: bold;
}

.addon-container .main-image{
    background-color: #f6f6f6;
}

.images-container .main-image{
    width: 80%;
}

.arrow-right,.arrow-left{
    position: absolute;
    top: 38%;
    font-size: 2.5vw;
    color: black;
}

.arrow-right{
    right: 11%;
}

.arrow-left{
    left: 2%;
}

.extra-images-container{
    display: flex;
    position: relative;
    width: 15%;
}

.extra-image{
    width: 100%;
    margin-bottom: 0.5rem;
    background-color: #f6f6f6;
    cursor: pointer;
}

.extra-image.selected{
    border: 1px solid black;
}


.data-container{
    width: 50%;
    position: relative;
}

.data-container .title{
    font-size: 2vw;
    color: #0f0c38;
    line-height: 1;
    margin-bottom: 0;
    width: 100%;
    font-weight: 700;
    margin-bottom: 0.5rem;
}

.x{
    position: absolute;
    top: 2%;
    right: 2%;
    width: 3%;
    cursor: pointer;
}

.ethos-container, .alergen-container{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    padding: 2% 0%;
}

.ethos-container span,.alergen-container span{
    background-color: white;
    border: 1px solid #F3EEFA;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1% 3%;
    font-size: 1.1vw;
    font-weight: bold;
    color: #5981d9;
    margin-right: 3%;
}

.ethos-container span.pink{
  background-color: #fbdaff;
}

.ethos-container span.green{
  background-color: #d8efdf;
}

.ethos-container span.yellow{
  background-color: #ffe7c7;
}

.ethos-container span.dgreen{
  background-color: #a9ffbd;
}

.ethos-container span.lyellow{
  background-color: #fffcdd;
}

.ethos-container .purple-ethos{
    background-color: #e3d8f6;
}

.data-container .desc{
    font-size: 1vw;
    line-height: 1.5;
    color: #0F0C38;
    border-radius: 8px;
    padding: 2%;
    background-color: #f6f6f6;
}

.desc-label{
    margin: unset;
    text-align: left;
    width: 100%;
    font-size: 1.3vw;
    font-weight: bold;
}

.recommendation-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-top: 0.5rem;
}

.recommendation-container .arrow{
    position: absolute;
    padding: 5px;
    top: 37%;
    cursor: pointer;
}

.arrow.left{
    left: -3%;
}

.arrow.right{
    right: -3%;
}

.recommendation-container .title{
    width: 100%;
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    color: #0F0C38;
    border-bottom: 1px solid lightgray;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.side-scroller{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    overflow-x: scroll;
    scroll-behavior: smooth;
    gap: 3%;
}

.recommended-addon{
    width: 12%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}

.recommended-addon .happybox-button{
    margin-top: 5%;
    font-size: 1vw;

}

.recommended-addon .addon-title,.recommended-addon .price{
    font-size: 0.8vw;
    line-height: 1.2;
    color: #0F0C38;
    margin-top: 0.5rem;
}

.recommended-addon .addon-title{
    font-weight: 700;
}

.recommended-addon .main-image{
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
}

.happybox-button.white{
    padding: 0% 0%;
}

//Selector container
.selector-container{
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

.selector-shown{
    width: 100%;
    display: flex;
    padding: 2% 1%;
    justify-content: center;
    background-color: #5cffc0;
    color: #0f0c38;
    text-align: center;
    text-decoration: none;
    cursor: pointer;
    border-radius: 40px;
    border: 1px solid #0F0C38;
}

.selector-shown:hover{
    background-color: white;
}

.selector-shown .quantity-show{
    width: 30%;
    line-height: 1;
    font-size: 1vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
}

.selector-shown .separator{
    border-left: 1px solid black;
    margin: unset;
}

.selector-shown .box-show{
    width: 65%;
    font-size: 1.2vw;
}

.selector-options{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
    position: absolute;
    top: 100%;
    z-index: 1;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(31, 41, 55, 0.1);
    border-radius: 4px;
    width: 100%;
}

.selector-options button{
    color: #0F0C38;
    font-size: 1.1vw;
    line-height: 1.3;
    padding: 8px;
    background: #FFFFFF;
    width: 100%;
    text-align: left;
}

.selector-options button:hover{
    background-color: #FAF7FE;
}

.selector-options button.custom{
    color: #8763B6;
}

.selector-options button.remove{
    color: #9CA3AF;
}

//SELECTOR END

.variant-container{
    width: 100%;
}

.variant-title{
    font-weight: 700;
    font-size: 1.3vw;
    line-height: 1.5;
    color: #0f0c38;
    padding: 2% 0%;
}

.variants-button-container{
    display: flex;
    align-items: center;
    justify-content: flex-start;
}

.variants-button-container button{
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    height: 3vw;
    width: 3vw;
    font-size: 1vw;
    border: 1px solid;
    color: #0f0c38;
    margin-right: 2%;
}

.variants-button-container button.selected{
    background-color: #BDF4DF;
}

.ingredient-container{
    font-size: 1.15vw;
    margin: 5% 0%;
}

.input-container{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.input-container .happybox-button{
    width: 70%;
}

.input-container input{
    color: #0f0c38;
    height: unset !important;
    font-weight: 700;
    line-height: 1;
}

.red-alert{
    color: #581C87;
    font-size: 1vw;
    cursor: pointer;
}
</style>